export const GET_STATS = "GET_STATS";
export const GET_SUMMARY_WEBSITE = "GET_SUMMARY_WEBSITE";
export const GET_SUMMARY_DATE = "GET_SUMMARY_DATE";

export const STRING = {
    COL: [
        { name: 'websites', title: 'Websites' },
        { name: 'websitesName', title: 'Website Name' },
        { name: 'requests', title: 'Requests' },
        { name: 'impressions', title: 'Impressions' },
        { name: 'clicks', title: 'Clicks' },
        { name: 'fillRate', title: 'Fill Rate%' },
        { name: 'ctr', title: 'CTR%' },
        { name: 'earnings', title: 'Earnings (LKR)' },
        { name: 'ecpm', title: 'eCPM (LKR)' },
        { name: 'ecpc', title: 'eCPC (LKR)' },  
    ],
    COLS: [
        { name: 'date', title: 'Date' },
        { name: 'requests', title: 'Requests' },
        { name: 'impressions', title: 'Impressions' },
        { name: 'clicks', title: 'Clicks' },
        { name: 'fillRate', title: 'Fill Rate%' },
        { name: 'ctr', title: 'CTR%' },
        { name: 'earnings', title: 'Earnings (LKR)' },
        { name: 'ecpm', title: 'eCPM (LKR)' },
        { name: 'ecpc', title: 'eCPC (LKR)' },  
    ],
}